// extracted by mini-css-extract-plugin
export default {"fullWidth":"Ln-z","image":"Mn-z","lazyLoadPicture":"Nn-z","lazyLoadSpinner":"On-z","lazyLoadSpin":"Pn-z","lazyLoadImage":"Qn-z","hasStyledAspectRatio":"Rn-z"};